import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/mousewheel";
import { motion, AnimatePresence } from "framer-motion";
import "./App.css";

// Add Shopify Buy Button configuration
const SHOPIFY_CONFIG = {
  domain: '40vve1-1p.myshopify.com',
  storefrontAccessToken: 'df352389f9b873d057634321e699495a',
  productId: '10235484864849'
};

const solitudeRequiemImage = new Image();
solitudeRequiemImage.src = "https://i.imgur.com/UdyJk84.jpeg";

// Предзагрузка обложки guntherapy для быстрого отображения
const guntherapyImage = new Image();
guntherapyImage.src =
  "https://res.cloudinary.com/drnptlojo/image/upload/f_webp,q_80/Y0CPRD1.webp";

// Компонент ProgressiveImage для прогрессивной загрузки изображений (эффект размытия)
function ProgressiveImage({ src, alt, style, disableContextMenu, ...props }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      src={src}
      alt={alt}
      style={{
        ...style,
        filter: loaded ? "none" : "blur(20px)",
        transition: "filter 0.5s ease-out",
      }}
      onLoad={() => setLoaded(true)}
      onContextMenu={disableContextMenu ? (e) => e.preventDefault() : undefined}
      {...props}
    />
  );
}

function Header() {
  return (
    <header className="site-header">
      <div
        className="logo-container"
        onClick={() => (window.location.href = "/")}
        style={{ cursor: "pointer" }}
      >
        <img src="/revetglogo.png" alt="Логотип" className="logo" />
      </div>
      <nav className="header-inner" aria-label="Main navigation">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            isActive ? "nav-btn active" : "nav-btn"
          }
        >
          Home
        </NavLink>
        <NavLink
          to="/music"
          className={({ isActive }) =>
            isActive ? "nav-btn active" : "nav-btn"
          }
        >
          Music
        </NavLink>
        <NavLink
          to="/inspiration"
          className={({ isActive }) =>
            isActive ? "nav-btn active" : "nav-btn"
          }
        >
          Inspiration
        </NavLink>
        <NavLink
          to="/video"
          className={({ isActive }) =>
            isActive ? "nav-btn active" : "nav-btn"
          }
        >
          Video
        </NavLink>
        <NavLink
          to="/merch"
          className={({ isActive }) =>
            isActive ? "nav-btn active" : "nav-btn"
          }
        >
          Merch
        </NavLink>
      </nav>
    </header>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-terms">
          <div className="footer-links">
            <a
              href="/terms-conditions"
              className="footer-link"
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                textDecoration: 'none',
                transition: 'color 0.3s ease',
                fontSize: '12px'
              }}
              onMouseEnter={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.9)'}
              onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}
            >
              terms & conditions
            </a>
            <span style={{ margin: '0 8px', color: 'rgba(255, 255, 255, 0.5)' }}>&</span>
            <a
              href="/privacy-policy"
              className="footer-link"
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                textDecoration: 'none',
                transition: 'color 0.3s ease',
                fontSize: '12px'
              }}
              onMouseEnter={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.9)'}
              onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}
            >
              privacy policy
            </a>
          </div>
        </div>

        <div className="social-icons">
          <a
            href="https://www.instagram.com/revetg_/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/instagram-new.png"
              alt="Instagram"
            />
          </a>
          <a
            href="https://www.youtube.com/@revetg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/youtube-play.png"
              alt="YouTube"
            />
          </a>
          <a
            href="https://t.me/revetg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/telegram-app.png"
              alt="Telegram"
            />
          </a>
          <a
            href="https://open.spotify.com/artist/2ZhIl5uiOEDnEyyz1s4aCp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/spotify.png"
              alt="Spotify"
            />
          </a>
          <a
            href="https://soundcloud.com/revetgg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/soundcloud.png"
              alt="SoundCloud"
            />
          </a>
          <a
            href="https://music.apple.com/at/artist/revetg/1480158868"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/apple-music.png"
              alt="Apple Music"
            />
          </a>
        </div>
        <div className="footer-text">2026 REVETG</div>
      </div>
    </footer>
  );
}

function Home() {
  return (
    <div className="tab-content club-killer-home">
      <h1>Club Killer</h1>
    </div>
  );
}

// Хук для отслеживания ширины окна
function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return width;
}

function Music() {
  const width = useWindowWidth();
  const isMobile = width < 768;

  const oldReleases = [
    {
      title: "Solitude Requiem",
      link: "https://band.link/SolitudeRequiem",
      image: "https://i.imgur.com/UdyJk84.jpeg",
    },
    {
      title: "guntherapy",
      link: "https://band.link/LbWr2",
      image:
        "https://res.cloudinary.com/drnptlojo/image/upload/f_webp,q_70,w_600/Y0CPRD1.webp",
      fallbackImage: "https://i.imgur.com/Y0CPRD1.jpeg",
    },
    {
      title: "met gala",
      link: "https://bfan.link/met-gala",
      image: "https://i.imgur.com/t2GLX0E.jpg",
    },
    {
      title: "be here",
      link: "https://band.link/revetgbehere",
      image: "https://i.imgur.com/A8BVehE.jpg",
    },
    {
      title: "SS25",
      link: "https://band.link/oRINs",
      image: "https://i.imgur.com/Rhg2JEk.jpg",
    },
    {
      title: "SS25 (Single)",
      link: "https://band.link/ss25",
      image: "https://i.imgur.com/3ooZI0z.jpg",
    },
  ];

  const newReleases = [
    {
      title: "POP-UP",
      link: "https://band.link/popupisopennow",
      image: "https://i.imgur.com/UWFius7.png",
    },
    {
      title: "@QUIT",
      link: "https://band.link/bWo5I",
      image: "https://i.imgur.com/wp1xVQq.jpeg",
    },
    {
      title: "@ALYX",
      link: "https://band.link/DbdRm",
      image: "https://i.imgur.com/l0cbugj.png",
    },
    {
      title: "AntiAntiAntiSocial",
      link: "https://muz.lc/AntiAntiAntiSocial",
      image: "https://i.imgur.com/dQWhCGF.jpeg",
    },
  ];

  const allReleases = [
    {
      title: "AntiAntiAntiSocial",
      link: "https://muz.lc/AntiAntiAntiSocial",
      image: "https://i.imgur.com/dQWhCGF.jpeg",
    },
    ...oldReleases,
    ...newReleases.filter(r => r.title !== "AntiAntiAntiSocial")
  ];
  const swiperRef = useRef(null);

  useEffect(() => {
    if (!isMobile && swiperRef.current && swiperRef.current.el) {
      const onWheel = (e) => {
        if (Math.abs(e.deltaY) > 50) {
          e.preventDefault();
          if (e.deltaY > 0) {
            swiperRef.current.slideNext();
          } else {
            swiperRef.current.slidePrev();
          }
        }
      };
      const swiperEl = swiperRef.current.el;
      swiperEl.addEventListener("wheel", onWheel);
      return () => {
        swiperEl.removeEventListener("wheel", onWheel);
      };
    }
  }, [isMobile]);

  if (isMobile) {
    return (
      <div className="tab-content music-tab-content">
        <div
          className="music-mobile"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "20px 0",
            height: "100%",
            overflowY: "auto",
          }}
        >
          {allReleases.map((release, idx) => (
            <div
              key={idx}
              className="release-mobile"
              style={{
                marginBottom: "20px",
                width: "280px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a
                href={release.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "#fff",
                  textAlign: "center",
                }}
              >
                <ProgressiveImage
                  src={release.image}
                  alt={release.title}
                  loading={release.title === "guntherapy" ? "eager" : "lazy"}
                  disableContextMenu={true}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                    transition: "transform 0.3s",
                    marginBottom: "10px",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1.0)")
                  }
                  onError={(e) => {
                    if (release.fallbackImage) {
                      e.target.src = release.fallbackImage;
                    }
                  }}
                />
                <div style={{ fontSize: "16px" }}>{release.title}</div>
              </a>
            </div>
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <div className="tab-content music-tab-content">
        <Swiper
          modules={[Navigation, Mousewheel]}
          simulateTouch={false}
          freeMode={{
            enabled: true,
            sticky: true,
            momentum: true,
            momentumRatio: 0.9,
            momentumVelocityRatio: 1.2,
            momentumBounce: false,
          }}
          grabCursor={true}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 2,
            invert: false,
            releaseOnEdges: false,
          }}
          navigation={true}
          loop={true}
          slidesPerView={4}
          slidesPerGroup={1}
          centeredSlides={false}
          spaceBetween={20}
          speed={300}
          tabIndex={0}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          style={{
            width: "100%",
            height: "80vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 20px",
          }}
        >
          {allReleases.map((release, idx) => (
            <SwiperSlide
              key={idx}
              style={{
                width: "240px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a
                href={release.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "#fff",
                  textAlign: "center",
                }}
              >
                <ProgressiveImage
                  src={release.image}
                  alt={release.title}
                  loading={release.title === "guntherapy" ? "eager" : "lazy"}
                  disableContextMenu={true}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                    transition: "transform 0.3s",
                    marginBottom: "10px",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1.0)")
                  }
                  onError={(e) => {
                    if (release.fallbackImage) {
                      e.target.src = release.fallbackImage;
                    }
                  }}
                />
                <div style={{ fontSize: "16px" }}>{release.title}</div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }
}

function Inspiration() {
  const inspirationItems = [
    { type: "image", src: "CleanShot_202026-03-30_20at_2020.00.40_402x.png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5.png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5(1).png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5(2).png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5(3).png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5(4).png" },
    {
      type: "soundcloud",
      title: "Lil Ugly Mane - Radiation",
      src: "https://w.soundcloud.com/player/?url=https%3A%2F%2Fsoundcloud.com%2Fangeline-basulto%2Fradiation-lung-pollution-ft&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true",
    },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5(5).png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5(6).png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5(7).png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5(8).png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5(9).png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5(10).png" },
    { type: "image", src: "_D0_B8_D0_B7_D0_BE_D0_B1_D1_80_D0_B0_D0_B6_D0_B5_D0_BD_D0_B8_D0_B5 copy.png" },
    { type: "image", src: "2026-07-06 11.48.27.jpg" },
  ];

  return (
    <div className="tab-content inspiration-page">
      <div className="inspiration-gallery">
        {inspirationItems.map((item, index) => (
          <div className="inspiration-item" key={item.src || item.videoId}>
            {item.type === "video" ? (
              <div className="inspiration-video">
                <iframe
                  src={`https://www.youtube.com/embed/${item.videoId}`}
                  title={item.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            ) : item.type === "soundcloud" ? (
              <div className="inspiration-soundcloud">
                <iframe
                  title={item.title}
                  scrolling="no"
                  frameBorder="no"
                  allow="autoplay"
                  src={item.src}
                ></iframe>
              </div>
            ) : (
              <ProgressiveImage
                src={`/inspiration-assets/${item.src}`}
                alt={`Inspiration ${index + 1}`}
                loading="lazy"
                style={{ width: "100%", height: "auto" }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function Video() {
  // Объявляем состояния для каждого видео
  const [hard2killLoaded, setHard2killLoaded] = useState(false);
  const [guntherapyLoaded, setGuntherapyLoaded] = useState(false);
  const [metGalaLoaded, setMetGalaLoaded] = useState(false);
  const [alyxLoaded, setAlyxLoaded] = useState(false);

  return (
    <div className="tab-content">
      {/* Новый клип "hard2kill" */}
      <div className="video-wrapper">
        <div className="video-container">
          {hard2killLoaded ? (
            <iframe
              src="https://www.youtube.com/embed/gLdL_ZO3YcE?autoplay=1"
              title="hard2kill"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div
              className="video-preview"
              onClick={() => setHard2killLoaded(true)}
            >
              <ProgressiveImage
                src="https://img.youtube.com/vi/gLdL_ZO3YcE/hqdefault.jpg"
                alt="hard2kill"
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div className="play-button"></div>
            </div>
          )}
        </div>
        <div className="video-caption">hard2kill</div>
      </div>

      {/* Клип "guntherapy" */}
      <div className="video-wrapper">
        <div className="video-container">
          {guntherapyLoaded ? (
            <iframe
              src="https://www.youtube.com/embed/vRHKAB7kvOY?autoplay=1"
              title="guntherapy"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div
              className="video-preview"
              onClick={() => setGuntherapyLoaded(true)}
            >
              <ProgressiveImage
                src="https://img.youtube.com/vi/vRHKAB7kvOY/hqdefault.jpg"
                alt="guntherapy"
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div className="play-button"></div>
            </div>
          )}
        </div>
        <div className="video-caption">guntherapy</div>
      </div>

      {/* Второй клип – "met gala" */}
      <div className="video-wrapper">
        <div className="video-container">
          {metGalaLoaded ? (
            <iframe
              src="https://www.youtube.com/embed/Yr13s_mp-00?autoplay=1"
              title="met gala"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div
              className="video-preview"
              onClick={() => setMetGalaLoaded(true)}
            >
              <ProgressiveImage
                src="https://img.youtube.com/vi/Yr13s_mp-00/hqdefault.jpg"
                alt="met gala"
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div className="play-button"></div>
            </div>
          )}
        </div>
        <div className="video-caption">met gala</div>
      </div>

      {/* Третий клип – "@ALYX" */}
      <div className="video-wrapper">
        <div className="video-container">
          {alyxLoaded ? (
            <iframe
              src="https://www.youtube.com/embed/72w7D73SnTE?autoplay=1"
              title="@ALYX"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div className="video-preview" onClick={() => setAlyxLoaded(true)}>
              <ProgressiveImage
                src="https://img.youtube.com/vi/72w7D73SnTE/hqdefault.jpg"
                alt="@ALYX"
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div className="play-button"></div>
            </div>
          )}
        </div>
        <div className="video-caption">@ALYX</div>
      </div>
    </div>
  );
}

function Merch() {
  const navigate = useNavigate();

  const tshirts = [
    {
      id: 1,
      name: "solitude requiem",
      price: "€35",
      images: [
        "/tshirt-solitude-requiem.png", // Main image
        "/tshirt-solitude-requiem-back.png", // Back view
      ],
      description: "pre-order now",
      fullDescription: "limited amount merch",
      details: [
        "100% cotton, DTF print",
        "worldwide shipping",
        "estimated delivery: september 2025",
        "unisex oversized fit",
        "limited amount"
      ],
      sizes: ["One Size"]
    }
  ];

  const handleTshirtClick = (tshirt) => {
    navigate(`/merch/${tshirt.id}`);
  };

  return (
    <div className="tab-content">
      <div className="merch">
        <motion.div
          className="tshirt-single"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {tshirts.map((tshirt, index) => (
            <motion.div
              key={tshirt.id}
              className="tshirt-single-item"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ scale: 1.02 }}
              onClick={() => handleTshirtClick(tshirt)}
              style={{ cursor: 'pointer' }}
            >
              <div className="tshirt-image-single">
                <ProgressiveImage
                  src={tshirt.images[0]}
                  alt={tshirt.name}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                    borderRadius: "8px"
                  }}
                />
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}

function TshirtDetail() {
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showImageModal, setShowImageModal] = useState(false);
  const [modalImageIndex, setModalImageIndex] = useState(0);

  // Product data - keeping consistent with existing design
  const tshirt = {
    id: 1,
    name: "solitude requiem",
    price: "€35",
    shopifyProductId: SHOPIFY_CONFIG.productId,
    images: [
      "/tshirt-solitude-requiem.png", // Main image
      "/tshirt-solitude-requiem-back.png", // Back view
    ],
    description: "pre-order now",
    fullDescription: "t-shirt with longer sleeve",
    details: [
      "100% cotton, DTF print",
      "worldwide shipping",
      "estimated delivery: september 2025",
      "unisex oversized fit",
      "limited amount"
    ],
    sizes: ["One Size"]
  };

  const openImageModal = (index) => {
    setModalImageIndex(index);
    setShowImageModal(true);
  };

  const closeImageModal = useCallback(() => {
    setShowImageModal(false);
  }, []);

  const nextImage = useCallback(() => {
    setModalImageIndex((prev) => (prev + 1) % tshirt.images.length);
  }, [tshirt.images.length]);

  const prevImage = useCallback(() => {
    setModalImageIndex((prev) => (prev - 1 + tshirt.images.length) % tshirt.images.length);
  }, [tshirt.images.length]);

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!showImageModal) return;

      if (e.key === 'Escape') {
        closeImageModal();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showImageModal, closeImageModal, nextImage, prevImage]);

  return (
    <div className="tab-content">
      <div className="tshirt-detail">
        <motion.button
          className="back-button"
          onClick={() => navigate('/merch')}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          whileHover={{ scale: 1.05 }}
        >
          ← back to merch
        </motion.button>

        <motion.div
          className="tshirt-detail-container"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="tshirt-detail-images">
            <motion.div
              className="main-image"
              key={currentImageIndex}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
              onClick={() => openImageModal(currentImageIndex)}
              style={{ cursor: 'pointer' }}
            >
              <ProgressiveImage
                src={tshirt.images[currentImageIndex]}
                alt={`${tshirt.name} - view ${currentImageIndex + 1}`}
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                  borderRadius: "12px",
                  transition: "transform 0.3s ease"
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              />
            </motion.div>

            <div className="image-thumbnails">
              {tshirt.images.map((image, index) => (
                <motion.div
                  key={index}
                  className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                  onClick={() => setCurrentImageIndex(index)}
                  onDoubleClick={() => openImageModal(index)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  style={{ cursor: 'pointer' }}
                >
                  <ProgressiveImage
                    src={image}
                    alt={`${tshirt.name} thumbnail ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "60px",
                      objectFit: "cover",
                      borderRadius: "6px"
                    }}
                  />
                </motion.div>
              ))}
            </div>
          </div>

          <div className="tshirt-detail-info">
            <motion.h1
              className="tshirt-detail-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {tshirt.name}
            </motion.h1>

            <motion.p
              className="tshirt-detail-price"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              {tshirt.price}
            </motion.p>

            <motion.p
              className="tshirt-detail-description"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              {tshirt.fullDescription}
            </motion.p>

            <motion.div
              className="tshirt-detail-specs"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              <h3>details:</h3>
              <ul>
                {tshirt.details.map((detail, index) => (
                  <li key={index}>{detail}</li>
                ))}
              </ul>
            </motion.div>

            <motion.div
              className="tshirt-detail-sizes"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <h3>available sizes:</h3>
              <div className="size-display">
                {tshirt.sizes.map((size, index) => (
                  <span key={index} className="size-chip">{size}</span>
                ))}
              </div>
            </motion.div>

            {/* Only keep the Shopify Buy Button - remove any other payment button */}
            <ShopifyBuyButton productId={tshirt.shopifyProductId} />
          </div>
        </motion.div>
      </div>

      {/* Image Modal */}
      <AnimatePresence>
        {showImageModal && (
          <motion.div
            className="image-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.9)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10000,
              padding: '20px'
            }}
            onClick={closeImageModal}
          >
            <motion.div
              className="image-modal-content"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                position: 'relative',
                maxWidth: '90vw',
                maxHeight: '90vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close button */}
              <button
                onClick={closeImageModal}
                style={{
                  position: 'absolute',
                  top: '-50px',
                  right: '0px',
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  color: 'white',
                  fontSize: '20px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10001
                }}
              >
                ×
              </button>

              {/* Navigation buttons */}
              {tshirt.images.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    style={{
                      position: 'absolute',
                      left: '-60px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'rgba(255, 255, 255, 0.2)',
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px',
                      color: 'white',
                      fontSize: '20px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 10001
                    }}
                  >
                    ←
                  </button>
                  <button
                    onClick={nextImage}
                    style={{
                      position: 'absolute',
                      right: '-60px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'rgba(255, 255, 255, 0.2)',
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px',
                      color: 'white',
                      fontSize: '20px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 10001
                    }}
                  >
                    →
                  </button>
                </>
              )}

              {/* Large image */}
              <motion.div
                key={modalImageIndex}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.3 }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <ProgressiveImage
                  src={tshirt.images[modalImageIndex]}
                  alt={`${tshirt.name} - enlarged view ${modalImageIndex + 1}`}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '80vh',
                    objectFit: 'contain',
                    borderRadius: '12px',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)'
                  }}
                />
              </motion.div>

              {/* Image counter */}
              <div style={{
                marginTop: '15px',
                color: 'white',
                fontSize: '14px',
                textAlign: 'center'
              }}>
                {modalImageIndex + 1} / {tshirt.images.length}
              </div>

              {/* Instructions */}
              <div style={{
                marginTop: '10px',
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '12px',
                textAlign: 'center'
              }}>
                Use arrow keys or click buttons to navigate • Press ESC to close
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function PaymentSuccess() {
  const navigate = useNavigate();

  return (
    <div className="tab-content">
      <div className="payment-success">
        <motion.div
          className="success-container"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            className="success-icon"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            ✓
          </motion.div>

          <motion.h1
            className="success-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            order confirmed!
          </motion.h1>

          <motion.p
            className="success-message"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.7 }}
          >
            thank you for your purchase of the "solitude requiem" t-shirt.
            you will receive a confirmation email shortly with your order details and tracking information.
          </motion.p>

          <motion.button
            className="success-button"
            onClick={() => navigate('/merch')}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.9 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            back to merch
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
}

function TermsConditions() {
  const navigate = useNavigate();

  return (
    <div className="tab-content">
      <div className="legal-page">
        <motion.button
          className="back-button"
          onClick={() => navigate(-1)}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          whileHover={{ scale: 1.05 }}
        >
          ← back
        </motion.button>

        <motion.div
          className="legal-container"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h1
            className="legal-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            terms & conditions
          </motion.h1>

          <motion.div
            className="legal-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <div className="legal-section">
              <h2>acceptance of terms</h2>
              <p>by accessing or using revetg merchandise services, you agree to be bound by these terms & conditions. if you disagree with any part of these terms, you may not access our services.</p>
            </div>

            <div className="legal-section">
              <h2>products & orders</h2>
              <p>all merchandise is subject to availability. we reserve the right to limit quantities of any products or services offered. product descriptions and pricing are subject to change without notice.</p>
              <p>pre-orders require full payment at time of purchase. estimated delivery times are approximate and may vary due to production or shipping circumstances.</p>
            </div>

            <div className="legal-section">
              <h2>payment & pricing</h2>
              <p>all prices are listed in euros (€) and include applicable taxes. payment is processed securely through stripe. we accept major credit cards and digital payment methods.</p>
              <p>prices are subject to change without notice. the price charged will be the price displayed at the time of purchase completion.</p>
            </div>

            <div className="legal-section">
              <h2>shipping & delivery</h2>
              <p>worldwide shipping is available for most locations. shipping costs and delivery times vary by destination. we are not responsible for delays caused by customs, weather, or carrier issues.</p>
              <p>risk of loss and title for merchandise passes to you upon delivery to the carrier.</p>
            </div>

            <div className="legal-section">
              <h2>returns & exchanges</h2>
              <p>in accordance with eu consumer protection laws, you have the right to return items within 14 days of delivery without giving a reason. items must be returned in their original condition with all tags and packaging intact.</p>
              <p>to initiate a return, contact us through our official channels. you are responsible for return shipping costs unless the item is defective or incorrectly sent.</p>
              <p>refunds will be processed within 14 days of receiving your returned item. for defective items, we offer replacement or full refund including original shipping costs.</p>
              <p>custom or personalized items, and items that cannot be returned for hygiene reasons, may be excluded from the right of withdrawal.</p>
            </div>

            <div className="legal-section">
              <h2>intellectual property</h2>
              <p>all designs, artwork, and branding are the exclusive property of revetg. unauthorized reproduction, distribution, or use of our intellectual property is strictly prohibited.</p>
            </div>

            <div className="legal-section">
              <h2>limitation of liability</h2>
              <p>revetg shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our products or services.</p>
            </div>

            <div className="legal-section">
              <h2>modifications</h2>
              <p>we reserve the right to modify these terms at any time. continued use of our services constitutes acceptance of any changes.</p>
            </div>

            <div className="legal-section">
              <h2>contact</h2>
              <p>for questions regarding these terms, contact us through our social media channels or official website.</p>
            </div>

            <div className="legal-footer">
              <p>last updated: july 2025</p>
              <p>© 2025 revetg. all rights reserved.</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="tab-content">
      <div className="legal-page">
        <motion.button
          className="back-button"
          onClick={() => navigate(-1)}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          whileHover={{ scale: 1.05 }}
        >
          ← back
        </motion.button>

        <motion.div
          className="legal-container"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h1
            className="legal-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            privacy policy
          </motion.h1>

          <motion.div
            className="legal-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <div className="legal-section">
              <h2>information we collect</h2>
              <p>we collect information you provide directly, such as when you make a purchase, create an account, or contact us. this may include your name, email address, shipping address, and payment information.</p>
              <p>we automatically collect certain information about your device and usage of our website through cookies and similar technologies.</p>
            </div>

            <div className="legal-section">
              <h2>how we use your information</h2>
              <p>we use your information to process orders, communicate with you, improve our services, and comply with legal obligations.</p>
              <p>we may send you promotional emails about new products or events. you can opt out at any time.</p>
            </div>

            <div className="legal-section">
              <h2>information sharing</h2>
              <p>we do not sell, trade, or rent your personal information to third parties. we may share information with trusted service providers who assist in operating our website and conducting business.</p>
              <p>we may disclose information when required by law or to protect our rights and safety.</p>
            </div>

            <div className="legal-section">
              <h2>payment processing</h2>
              <p>payment information is processed securely through stripe. we do not store your complete credit card information on our servers.</p>
              <p>stripe's privacy policy governs the handling of your payment data during transactions.</p>
            </div>

            <div className="legal-section">
              <h2>cookies & tracking</h2>
              <p>we use cookies to enhance your browsing experience, analyze website traffic, and personalize content. you can control cookie settings through your browser.</p>
              <p>we may use analytics tools to understand how visitors interact with our website.</p>
            </div>

            <div className="legal-section">
              <h2>data security</h2>
              <p>we implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
              <p>however, no method of transmission over the internet is 100% secure.</p>
            </div>

            <div className="legal-section">
              <h2>data retention</h2>
              <p>we retain your information for as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required by law.</p>
            </div>

            <div className="legal-section">
              <h2>your rights</h2>
              <p>you have the right to access, update, or delete your personal information. you may also object to certain processing activities.</p>
              <p>to exercise these rights, contact us through our official channels.</p>
            </div>

            <div className="legal-section">
              <h2>children's privacy</h2>
              <p>our services are not directed to individuals under 16. we do not knowingly collect personal information from children.</p>
            </div>

            <div className="legal-section">
              <h2>international transfers</h2>
              <p>your information may be transferred to and processed in countries other than your country of residence. we ensure appropriate safeguards are in place.</p>
            </div>

            <div className="legal-section">
              <h2>policy updates</h2>
              <p>we may update this privacy policy periodically. we will notify you of any material changes by posting the new policy on our website.</p>
            </div>

            <div className="legal-section">
              <h2>contact information</h2>
              <p>for questions about this privacy policy or our privacy practices, reach out through our social media channels or official website.</p>
            </div>

            <div className="legal-footer">
              <p>last updated: july 2025</p>
              <p>© 2025 revetg. all rights reserved.</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}

// Global Shopify UI instance on window object for better cleanup
if (!window.globalShopifyUIInstance) {
  window.globalShopifyUIInstance = null;
}

// Updated Shopify Buy Button component with aggressive cleanup
function ShopifyBuyButton({ productId }) {
  const shopifyContainerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const containerElement = shopifyContainerRef.current;

    // AGGRESSIVE CLEANUP BEFORE INITIALIZATION
    console.log('Before cleanup - Shopify components:', document.querySelectorAll('[data-shopify-buy-ui]').length);

    if (window.globalShopifyUIInstance) {
      try {
        window.globalShopifyUIInstance.destroy();
      } catch (e) {
        console.log('Pre-init cleanup error:', e);
      }
      window.globalShopifyUIInstance = null;
    }

    // Clear container completely
    if (containerElement) {
      containerElement.innerHTML = '';
    }

    // Remove ALL Shopify components from entire document
    const existingComponents = document.querySelectorAll('[data-shopify-buy-ui]');
    existingComponents.forEach(element => {
      element.remove();
    });

    console.log('After cleanup - Shopify components:', document.querySelectorAll('[data-shopify-buy-ui]').length);

    const loadShopifyScript = () => {
      const existingScript = document.querySelector('script[src*="buy-button-storefront"]');

      if (window.ShopifyBuy) {
        // Add delay to ensure DOM is clean
        setTimeout(() => {
          initializeShopifyButton();
        }, 100);
        return;
      }

      if (existingScript) {
        existingScript.onload = () => {
          setTimeout(() => {
            initializeShopifyButton();
          }, 100);
        };
        return;
      }

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
      script.onload = () => {
        setTimeout(() => {
          initializeShopifyButton();
        }, 100);
      };
      script.onerror = () => {
        setError('Failed to load Shopify SDK');
        setIsLoading(false);
      };
      (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
    };

    const initializeShopifyButton = () => {
      if (!window.ShopifyBuy || !shopifyContainerRef.current) {
        setError('Shopify SDK not available');
        setIsLoading(false);
        return;
      }

      try {
        // Final check - ensure container is still clean
        if (shopifyContainerRef.current) {
          shopifyContainerRef.current.innerHTML = '';
        }

        const client = window.ShopifyBuy.buildClient({
          domain: SHOPIFY_CONFIG.domain,
          storefrontAccessToken: SHOPIFY_CONFIG.storefrontAccessToken,
        });

        window.ShopifyBuy.UI.onReady(client).then((ui) => {
          // Store the UI instance globally for cleanup
          window.globalShopifyUIInstance = ui;

          // Check if container still exists
          if (!shopifyContainerRef.current) {
            return;
          }

          ui.createComponent('product', {
            id: productId,
            node: shopifyContainerRef.current,
            moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
            options: {
              "product": {
                "styles": {
                  "product": {
                    "@media (min-width: 601px)": {
                      "max-width": "100%",
                      "margin-left": "0px",
                      "margin-bottom": "0px"
                    }
                  },
                  "button": {
                    "font-family": "AvenirUltraLightItalic, sans-serif",
                    "font-size": "20px",
                    "padding": "16px 32px",
                    "background-color": "rgba(255, 255, 255, 0.1)",
                    "border": "1px solid rgba(255, 255, 255, 0.3)",
                    "border-radius": "12px",
                    "color": "white",
                    "text-transform": "lowercase",
                    "letter-spacing": "0.5px",
                    "transition": "all 0.3s ease",
                    "backdrop-filter": "blur(10px)",
                    "width": "100%",
                    "max-width": "300px",
                    ":hover": {
                      "background-color": "rgba(255, 255, 255, 0.2)",
                      "border-color": "rgba(255, 255, 255, 0.5)",
                      "transform": "scale(1.02)"
                    },
                    ":focus": {
                      "background-color": "rgba(255, 255, 255, 0.2)",
                      "border-color": "rgba(255, 255, 255, 0.5)",
                      "outline": "none"
                    }
                  },
                  "title": {
                    "display": "none"
                  },
                  "price": {
                    "display": "none"
                  },
                  "compareAt": {
                    "display": "none"
                  }
                },
                "buttonDestination": "checkout",
                "text": {
                  "button": "pre-order"
                },
                "contents": {
                  "img": false,
                  "title": false,
                  "price": false,
                  "options": false
                }
              },
              "modalProduct": {
                "contents": {
                  "img": false,
                  "imgWithCarousel": true,
                  "button": false,
                  "buttonWithQuantity": true
                },
                "styles": {
                  "product": {
                    "@media (min-width: 601px)": {
                      "max-width": "100%",
                      "margin-left": "0px",
                      "margin-bottom": "0px"
                    }
                  },
                  "button": {
                    "font-family": "AvenirUltraLightItalic, sans-serif",
                    "background-color": "rgba(255, 255, 255, 0.1)",
                    "border": "1px solid rgba(255, 255, 255, 0.3)",
                    "border-radius": "12px",
                    "color": "white",
                    ":hover": {
                      "background-color": "rgba(255, 255, 255, 0.2)"
                    },
                    ":focus": {
                      "background-color": "rgba(255, 255, 255, 0.2)"
                    }
                  }
                },
                "text": {
                  "button": "Add to cart"
                }
              },
              "cart": {
                "styles": {
                  "button": {
                    "font-family": "AvenirUltraLightItalic, sans-serif",
                    "background-color": "rgba(255, 255, 255, 0.1)",
                    "border": "1px solid rgba(255, 255, 255, 0.3)",
                    "border-radius": "12px",
                    "color": "white",
                    ":hover": {
                      "background-color": "rgba(255, 255, 255, 0.2)"
                    },
                    ":focus": {
                      "background-color": "rgba(255, 255, 255, 0.2)"
                    }
                  }
                },
                "text": {
                  "total": "Subtotal",
                  "button": "Checkout"
                }
              },
              "toggle": {
                "styles": {
                  "toggle": {
                    "font-family": "AvenirUltraLightItalic, sans-serif",
                    "background-color": "rgba(255, 255, 255, 0.1)",
                    "border": "1px solid rgba(255, 255, 255, 0.3)",
                    "color": "white",
                    ":hover": {
                      "background-color": "rgba(255, 255, 255, 0.2)"
                    },
                    ":focus": {
                      "background-color": "rgba(255, 255, 255, 0.2)"
                    }
                  }
                }
              }
            }
          });
          setIsLoading(false);
        }).catch((err) => {
          console.error('Shopify UI initialization error:', err);
          setError('Failed to initialize Shopify button');
          setIsLoading(false);
        });
      } catch (err) {
        console.error('Shopify client error:', err);
        setError('Failed to create Shopify client');
        setIsLoading(false);
      }
    };

    loadShopifyScript();

    // CLEANUP ON UNMOUNT - More aggressive cleanup
    return () => {
      console.log('Unmounting - cleaning up Shopify components');

      // Destroy the global UI instance
      if (window.globalShopifyUIInstance) {
        try {
          window.globalShopifyUIInstance.destroy();
        } catch (e) {
          console.log('Error destroying UI instance on cleanup:', e);
        }
        window.globalShopifyUIInstance = null;
      }

      // Clear the container
      if (containerElement) {
        containerElement.innerHTML = '';
      }

      // Remove any remaining Shopify Buy Button components from the DOM
      const remainingComponents = document.querySelectorAll('[data-shopify-buy-ui]');
      remainingComponents.forEach(element => {
        try {
          element.remove();
        } catch (e) {
          console.log('Error removing Shopify component:', e);
        }
      });

      console.log('After unmount cleanup - Shopify components:', document.querySelectorAll('[data-shopify-buy-ui]').length);
    };
  }, [productId]);

  if (error) {
    return (
      <motion.div
        className="payment-error"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
      >
        <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '14px', textAlign: 'center' }}>
          Payment system temporarily unavailable.<br />
          Please contact us directly to place your order.
        </p>
      </motion.div>
    );
  }

  return (
    <motion.div
      className="shopify-buy-button-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.7 }}
    >
      {isLoading && (
        <div style={{
          padding: '16px 32px',
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 0.7)',
          fontSize: '14px'
        }}>
          Loading payment options...
        </div>
      )}
      <div ref={shopifyContainerRef} />
    </motion.div>
  );
}

// Компонент Layout – фиксирует Header и Footer вне анимаций
function Layout({ children }) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      overflow: 'hidden',
      position: 'relative'
    }}>
      <Header />
      <main style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: isHomePage ? 'hidden' : 'auto'
      }}>
        {children}
      </main>
      <Footer />
    </div>
  );
}

// AppContent: здесь только основной контент (маршруты) анимируется,
// а Header и Footer остаются вне анимации благодаря Layout.
function AppContent() {
  const location = useLocation();
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (isFirstLoad) {
      setIsFirstLoad(false);
    }
    // Эта функция обработчика больше не используется, но оставлена для возможного будущего использования
    const handleMouseMove = () => {
      // Код обработчика удален, так как переменная x не используется
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [location, isFirstLoad]);

  // Add cleanup when route changes to prevent Shopify button duplicates
  useEffect(() => {
    return () => {
      if (window.globalShopifyUIInstance) {
        try {
          window.globalShopifyUIInstance.destroy();
        } catch (e) {
          console.log('Route cleanup error:', e);
        }
        window.globalShopifyUIInstance = null;
      }

      // Remove all Shopify components when navigating away
      const shopifyComponents = document.querySelectorAll('[data-shopify-buy-ui]');
      shopifyComponents.forEach(element => {
        try {
          element.remove();
        } catch (e) {
          console.log('Route cleanup component removal error:', e);
        }
      });
    };
  }, [location.pathname]);

  return (
    <div className={`App ${location.pathname === '/' ? 'club-killer-page' : ''}`}>
      <Layout>
        <main style={{ flex: 1 }}>
          <AnimatePresence mode="wait">
            <Routes location={location}>
              <Route
                path="/"
                element={
                  <motion.div
                    className="home-route"
                    initial={isFirstLoad ? {} : { opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Home />
                  </motion.div>
                }
              />
              <Route
                path="/music"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Music />
                  </motion.div>
                }
              />
              <Route
                path="/inspiration"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Inspiration />
                  </motion.div>
                }
              />
              <Route
                path="/video"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Video />
                  </motion.div>
                }
              />
              <Route
                path="/merch"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Merch />
                  </motion.div>
                }
              />
              <Route
                path="/merch/success"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <PaymentSuccess />
                  </motion.div>
                }
              />
              <Route
                path="/merch/:id"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <TshirtDetail />
                  </motion.div>
                }
              />
              <Route
                path="/terms-conditions"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <TermsConditions />
                  </motion.div>
                }
              />
              <Route
                path="/privacy-policy"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <PrivacyPolicy />
                  </motion.div>
                }
              />
            </Routes>
          </AnimatePresence>
        </main>
      </Layout>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
